import { render, staticRenderFns } from "./NNTPopup.vue?vue&type=template&id=a2a44b58&"
import script from "./NNTPopup.js?vue&type=script&lang=js&"
export * from "./NNTPopup.js?vue&type=script&lang=js&"
import style0 from "./NNTPopup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports